export default __webpack_public_path__ + "static/teemates-0da53f82d3ef08fb51a843e9a38c5090.webp";